export  const checkInternet = ()=>{
    if (navigator.onLine) {
        return true
    }
    return false
}